import.meta.globEager('/assets/images/**/*.{jpg,jpeg,png}', {
	query: { format: 'webp' },
});

import { vars } from './config/variables';

import { disableScroll, enableScroll, getDeviceType, classInstance } from '@/shared/helpers/helpers';

import { PictureLazy } from '@/shared/common/picture/picture';
import { Collapse } from '@/shared/common/collapse/collapse';
import { Dropdown } from '@/shared/common/dropdown/dropdown';
import { BreadcrumbsDropdown } from '@/shared/common/breadcrumbs/breadcrumbs-dropdown';
import { Popover } from '@/shared/common/popover/popover';
import { Scrollbar } from '@/shared/common/scrollbar/scrollbar';
import { Scrollto } from '@/shared/common/scrollto/scrollto';
import { Sticky } from '@/shared/common/sticky/sticky';
import { Tabs } from '@/shared/common/tabs/tabs';
import { Timer } from '@/shared/common/timer/timer';
import { Video } from '@/shared/common/video/video';
import { VideoCard } from '@/shared/common/video/video-card';
import { VideoMascot } from '@/shared/common/video/video-mascot';
import { ShowMore } from '@/shared/common/show-more/show-more';
import { CollapseBox } from '@/shared/common/collapse-box/collapse-box';
import { CopyField } from '@/shared/common/copy-field/copy-field';
import { AnimatedCounter } from '@/shared/animated-counter/animated-counter';

import { Form } from '@/shared/form/form';
import { Modal } from '@/shared/modal/modal';
import { ModalFormReset } from '@/shared/modal/modal-form-reset';
import { Notify } from '@/shared/notify/notify';
//import InitCookie from '@/features/cookie/cookie';
import { initCatalogMenu } from '@/features/catalog-menu/catalog-menu';
import { initExplodedViews } from '@/components/block/exploded-view/exploded-view';
import { Counter } from '@/shared/counter/counter';
import { AddToCart } from '@/shared/add-to-cart/add-to-cart';
import { CardProductGallery } from '@/components/card/card-product/card-product-gallery';
import { Search } from '@/features/search/search';
import { getValidateMessage } from '@/api/services/validate-message';

window.app = {};
window.vars = vars;
window.app.validateMessage = getValidateMessage();

window.app.classInstance = classInstance;
window.app.disableScroll = disableScroll;
window.app.enableScroll = enableScroll;
window.app.getDeviceType = getDeviceType;

window.app.PictureLazy = PictureLazy;
window.app.Collapse = Collapse;
window.app.Dropdown = Dropdown;
window.app.BreadcrumbsDropdown = BreadcrumbsDropdown;
window.app.Popover = Popover;
window.app.Scrollbar = Scrollbar;
window.app.Scrollto = Scrollto;
window.app.Sticky = Sticky;
window.app.Tabs = Tabs;
window.app.Timer = Timer;
window.app.Video = Video;
window.app.CardProductGallery = CardProductGallery;

window.app.Form = Form;
window.app.Notify = Notify;
window.app.Modal = Modal;
window.app.Search = Search;

function appInit() {
	document.querySelectorAll('picture.js-lazy').forEach((element) => new PictureLazy(element));
	document.querySelectorAll('.js-collapse').forEach((element) => new Collapse(element));
	document.querySelectorAll('.js-dropdown').forEach((element) => new Dropdown(element));
	document.querySelectorAll('.js-breadcrumbs-dropdown').forEach((element) => new BreadcrumbsDropdown(element));
	document.querySelectorAll('.js-popover').forEach((element) => new Popover(element));
	document.querySelectorAll('.js-scrollbar').forEach((element) => new Scrollbar(element));
	document.querySelectorAll('.js-scrollto').forEach((element) => new Scrollto(element));
	document.querySelectorAll('.js-tabs').forEach((element) => new Tabs(element));
	document.querySelectorAll('.js-video').forEach((element) => new Video(element));
	document.querySelectorAll('.js-video-card').forEach((element) => new VideoCard(element));
	document.querySelectorAll('.js-video-mascot').forEach((element) => new VideoMascot(element));
	document.querySelectorAll('.js-show-more').forEach((element) => new ShowMore(element));
	document.querySelectorAll('.js-card-product-gallery').forEach((element) => new CardProductGallery(element));
	document.querySelectorAll('.js-counter').forEach((element) => new Counter(element));
	document.querySelectorAll('.js-animated-counter').forEach((element) => new AnimatedCounter(element));
	document.querySelectorAll('.js-add-to-cart').forEach((element) => new AddToCart(element));
	document.querySelectorAll('.js-collapse-box').forEach((element) => new CollapseBox(element));
	document.querySelectorAll('.js-copy-field').forEach((element) => new CopyField(element));
	document.querySelectorAll('.js-form').forEach((element) => new Form(element));
	document.querySelectorAll('.js-search').forEach((element) => new Search(element));
	new Notify();
	new Modal();
	new ModalFormReset();
	initCatalogMenu();
	initExplodedViews();
}

window.app.init = appInit;

window.addEventListener('DOMContentLoaded', () => {
	appInit();
});

/* App wide components */
import { header } from '@/widgets/header/header';
import { footer } from '@/widgets/footer/footer';

window.addEventListener('DOMContentLoaded', () => {
	header();
	footer();
});

/* Standalone methods */
import { showModalCallback } from '@/features/modal/modal-callback/modal-callback';
import { showModalToOrder } from '@/features/modal/modal-to-order/modal-to-order';
import { showModalMessageSent } from '@/features/modal/modal-message-sent/modal-message-sent';
import { handleFormError } from '@/shared/form/form-error-handler';
import { setPreviewText } from '@/shared/form/form-preview-text';
import { cardProductInit } from '@/components/card/card-product/card-product-init';

window.app.showModalCallback = showModalCallback;
window.app.showModalToOrder = showModalToOrder;
window.app.showModalMessageSent = showModalMessageSent;
window.app.handleFormError = handleFormError;
window.app.setPreviewText = setPreviewText;
window.app.cardProductInit = cardProductInit;

/* Authorization */
import { CodeForm } from '@/features/authorization/code-form/code-form';
import { AuthorizationForm } from '@/features/authorization/authorization-form/authorization-form';
import { AuthorizationTel } from '@/features/authorization/authorization-tel/authorization-tel';
import { RestorePassword } from '@/features/authorization/restore-password/restore-password';
import { Register } from '@/features/authorization/register/register';

window.addEventListener('DOMContentLoaded', () => {
	window.app.loginTelCode = new CodeForm(document.querySelector('#login-tel-code'));
	window.app.loginTelForm = new AuthorizationForm(document.querySelector('#login-tel-form'));
	window.app.loginTel = new AuthorizationTel(document.querySelector('#login-tel'));
	window.app.loginEmail = new AuthorizationForm(document.querySelector('#login-email'));
	window.app.registerTelForm = new AuthorizationForm(document.querySelector('#register-tel-form'));
	window.app.registerTelCode = new CodeForm(document.querySelector('#register-tel-code'));
	window.app.restoreSuccess = new RestorePassword(document.querySelector('#restore-password'), '#modal-restore-success');
	window.app.registerEmail = new AuthorizationForm(document.querySelector('#register-email'));
	window.app.registerTel = new AuthorizationTel(document.querySelector('#register-tel'));
	window.app.registerSuccess = new Register(window.app.registerEmail, window.app.registerTel, '#modal-register-success');
});
